import CryptoJS from 'crypto-js';
import { jwtDecode, JwtPayload } from 'jwt-decode';

/**
 * Pad or truncate a string to the required length (default: 16)
 */
const ensureProperLength = (input: string, length: number): string => {
  if (!input) return ''.padEnd(length, '0');
  return input.length >= length
    ? input.substring(0, length)
    : input.padEnd(length, '0');
};

/**
 * Decrypt an AES-encrypted message using key/IV from JWT.
 */
export const decryptMessage = (encryptedMessage: string, jwt: string): any | null => {
  try {
    const parsedToken = jwtDecode<JwtPayload & { sub?: string; jti?: string; email?: string }>(jwt);

    const key = ensureProperLength(parsedToken?.sub || '', 16);
    const iv = ensureProperLength(parsedToken?.jti || parsedToken?.email || '', 16);

    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedMessage,
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

    // Parse JSON only if it's valid
    const decryptedObject = JSON.parse(decryptedText);
    return decryptedObject;

  } catch (error: any) {
    console.error('Decryption failed:', error.message || error);
    return null;
  }
};